import currency from "currency.js";

const convertTry = (value) =>
  currency(value, {
    precision: 2,
    decimal: ",",
    separator: ".",
    symbol: ""
  }).format();

export default convertTry;
